import { useState, useEffect, useRef } from 'react';

const faqs = [
  {
    q: '91免费视频真的完全免费吗？',
    a: '是的，91免费视频上的所有视频内容完全免费，您无需支付任何费用即可观看。我们通过广告收入维持平台运营，确保用户始终能够享受免费的优质视频服务。',
  },
  {
    q: '需要注册账号才能观看视频吗？',
    a: '不需要！91免费视频坚持"打开即看"的理念，您无需注册账号即可直接观看所有视频内容。我们尊重用户隐私，不强制收集任何个人信息。',
  },
  {
    q: '支持哪些设备观看？',
    a: '91免费视频支持手机（iOS/Android）、平板电脑和PC电脑等多种设备。我们的网站采用响应式设计，能够自动适配不同屏幕尺寸，确保在任何设备上都能获得流畅的观看体验。',
  },
  {
    q: '视频画质怎么样？支持高清吗？',
    a: '我们提供最高1080P的高清视频画质。视频加载速度经过CDN加速优化，在网络良好的情况下可以流畅播放高清视频，给您带来优质的观看体验。',
  },
  {
    q: '视频内容多久更新一次？',
    a: '我们的内容团队每天都会更新新的视频内容，确保用户始终有新鲜的内容可以观看。热门分类如娱乐综艺、科技数码等更新频率更高，让您不错过任何精彩。',
  },
  {
    q: '如何找到我感兴趣的视频？',
    a: '您可以通过首页的搜索功能直接搜索关键词，也可以浏览十大视频分类来发现自己喜欢的内容。首页还会根据热门程度推荐优质视频，帮您快速找到精彩内容。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const schemaInserted = useRef(false);

  useEffect(() => {
    if (schemaInserted.current) return;
    schemaInserted.current = true;

    const schemaData = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((faq) => ({
        '@type': 'Question',
        name: faq.q,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.a,
        },
      })),
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-schema', 'faq');
    script.textContent = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      const el = document.querySelector('script[data-schema="faq"]');
      if (el) el.remove();
    };
  }, []);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-500">关于91免费视频，您可能想了解的问题</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-50 border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">{faq.q}</span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-400 text-lg"></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}